module.exports = __webpack_public_path__ + "img/icon-plus.0a152acb.svg";